import { render } from "./ColorChangeAnimation.vue?vue&type=template&id=487d8880&scoped=true&ts=true"
import script from "./ColorChangeAnimation.ts?vue&type=script&lang=ts"
export * from "./ColorChangeAnimation.ts?vue&type=script&lang=ts"

import "./ColorChangeAnimation.scss?vue&type=style&index=0&id=487d8880&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487d8880"]])

export default __exports__